import React, {
  useEffect,
  useState,
} from "react";

import {
  useParams,
} from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

import {
  FaBell,
} from "react-icons/fa";

const NoticePage = () => {
  const { id } =
    useParams();

  const [notice, setNotice] =
    useState(null);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/notices"
    )
      .then((res) =>
        res.json()
      )
      .then((data) => {
        const selected =
          data.find(
            (n) =>
              n.id === Number(id)
          );

        setNotice(selected);
      });
  }, [id]);

  if (!notice)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7f9fc]">

        <div className="text-center">

          <div className="w-16 h-16 border-4 border-[#0B4F9C] border-t-transparent rounded-full animate-spin mx-auto"></div>

          <h2 className="mt-5 text-2xl font-bold text-[#072F5F]">

            Loading Notice...

          </h2>

        </div>

      </div>
    );

  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section className="w-full bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#072F5F] py-20 md:py-28 relative overflow-hidden">

        {/* BACKGROUND DESIGN */}
        <div className="absolute inset-0 opacity-10">

          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl"></div>

        </div>

        <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-center">

          <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-md flex items-center justify-center text-white text-3xl mx-auto shadow-2xl">

            <FaBell />

          </div>

          <span className="inline-block mt-6 text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            School Notice

          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-5 leading-tight max-w-5xl mx-auto">

            {notice.title}

          </h1>

        </div>

      </section>

      {/* NOTICE CONTENT */}
      <section className="w-full bg-[#f7f9fc] py-16 md:py-24 overflow-x-hidden">

        <div className="max-w-5xl mx-auto px-5 md:px-10">

          <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 overflow-hidden">

            {/* TOP BAR */}
            <div className="h-3 bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#D4A017]"></div>

            {/* CONTENT */}
            <div className="p-8 md:p-14">

              <div className="flex items-center gap-4 mb-8">

                <div className="w-14 h-14 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-xl">

                  <FaBell />

                </div>

                <div>

                  <h2 className="text-2xl md:text-3xl font-bold text-[#072F5F]">

                    Official Announcement

                  </h2>

                  <div className="w-16 h-[3px] bg-[#D4A017] rounded-full mt-2"></div>

                </div>

              </div>

              <div className="text-gray-700 text-lg leading-10 whitespace-pre-line">

                {notice.content}

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default NoticePage;